import * as styles from './index.css';

export function ProgressBar({ progress }: { progress: number }) {
  return (
    <div className={styles.progressBar}>
      <div
        className={styles.progressBarFill}
        style={{
          width: `${progress}%`,
        }}
      ></div>
    </div>
  );
}
